import { render, staticRenderFns } from "./DeviceDetails.vue?vue&type=template&id=5ba7481b&scoped=true&"
import script from "./DeviceDetails.vue?vue&type=script&lang=js&"
export * from "./DeviceDetails.vue?vue&type=script&lang=js&"
import style0 from "./DeviceDetails.vue?vue&type=style&index=0&id=5ba7481b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba7481b",
  null
  
)

export default component.exports